import { IS_CLIENT } from '@repo/common-utils';
import { useMemo } from 'react';
import type { FetchFunction } from 'relay-runtime';
import { Environment, Network, RecordSource, RelayFeatureFlags, Store } from 'relay-runtime';

import useFetchRelayFactory from './use-fetch-relay-factory';

import { RelayLogger, RelayRequiredFieldLogger } from '@/lib/relay/relay-loggers';

RelayFeatureFlags.ENABLE_RELAY_RESOLVERS = true;

let relayEnvironment: Environment;
let relayApiToken: string | undefined;

const createEnvironment = (fetchFn: FetchFunction) =>
  new Environment({
    network: Network.create(fetchFn),
    store: new Store(new RecordSource()),
    log: RelayLogger,
    relayFieldLogger: RelayRequiredFieldLogger
  });

type InitialRecords = ConstructorParameters<typeof RecordSource>[number];
export const initEnvironment = ({
  initialRecords,
  fetchFn,
  apiToken
}: {
  initialRecords?: InitialRecords;
  fetchFn: FetchFunction;
  apiToken?: string;
}): Environment => {
  let environment;
  if (relayApiToken !== apiToken || !relayEnvironment) {
    environment = createEnvironment(fetchFn);
  } else {
    environment = relayEnvironment;
  }

  if (initialRecords) {
    environment.getStore().publish(new RecordSource(initialRecords));
  }

  if (!IS_CLIENT) {
    return environment;
  }

  relayApiToken = apiToken;
  relayEnvironment = environment;

  return relayEnvironment;
};

export const useEnvironment = (initialRecords: InitialRecords, apiToken: string, zentSessionId: string, zentClientSessionId: string): Environment => {
  const fetchFn = useFetchRelayFactory(apiToken, zentSessionId, zentClientSessionId);
  return useMemo(() => initEnvironment({ initialRecords, fetchFn, apiToken }), [initialRecords, fetchFn, apiToken]);
};
